import { useTranslation } from 'react-i18next'
import { Modal } from '@proaxiv/ui'
import { Button } from './Button'

interface Props {
  title: string
  message: string
  onClose: () => void
}

/** Simple acknowledgement-only popup for surfacing a single error message. */
export function ErrorModal({ title, message, onClose }: Props) {
  const { t } = useTranslation()

  return (
    <Modal role="alertdialog" labelledBy="error-modal-title">
      <div className="border-pax-purple/50 w-full max-w-md rounded-2xl border bg-white p-6 shadow-2xl ring-1 ring-black/5">
        <h2 id="error-modal-title" className="text-pax-black mb-2 text-xl font-bold">
          {title}
        </h2>
        <p role="alert" className="text-pax-gray mb-6 text-sm">
          {message}
        </p>
        <div className="flex justify-end">
          <Button variant="primary" onClick={onClose}>
            {t('btn_close')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
